import React, {FC} from 'react';
import {Tooltip} from "@mui/material";
import {ButtonSwitchButton, ButtonSwitchGroup, ButtonSwitchPadding} from "./button-styles";

export interface ButtonSwitchProps {
  primarySelected: boolean;
  onChange: (value: boolean) => void;
  optionLabels?: [string, string];
  disableSecondary?: boolean;
  disabledSecondaryLabel?: string;
}

const ButtonSwitch: FC<ButtonSwitchProps> = ({
  primarySelected = true,
  onChange,
  optionLabels = ["On", "Off"],
  disableSecondary = false,
  disabledSecondaryLabel = ""
}) => {
  return (
    <ButtonSwitchGroup aria-label="outlined primary button group">
      <ButtonSwitchPadding>
        <ButtonSwitchButton
          className={'d-flex ss-tab-btn'}
          onClick={() => onChange(true)}
          variant={primarySelected ? "contained" : "outlined"}
          color={primarySelected ? "primary" : "secondary"}
        >
          {optionLabels[0] || ""}
        </ButtonSwitchButton>
        {disableSecondary ? (
          <Tooltip title={disabledSecondaryLabel} placement="top" arrow>
            <span>
              <ButtonSwitchButton className={'d-flex ss-tab-btn'} disabled>
                {optionLabels[1] || ""}
              </ButtonSwitchButton>
            </span>
          </Tooltip>
        ) : (
          <ButtonSwitchButton
            className={'d-flex ss-tab-btn'}
            onClick={() => onChange(false)}
            variant={!primarySelected ? "contained" : "outlined"}
            color={!primarySelected ? "primary" : "secondary"}
          >
            {optionLabels[1] || ""}
          </ButtonSwitchButton>
        )}
      </ButtonSwitchPadding>
    </ButtonSwitchGroup>
  );
};

export default ButtonSwitch;
